import * as types from '../constants/ActionTypes';
import $ from "jquery";
import { delay } from  '../components/Animations/helper'
import * as GameViewMode from '../constants/GameViewMode'

export function loadGameJSON(urlString) {
    console.log('load game json via url', urlString);

	return (dispatch) => {
        $.ajax({
            url: "https://" + window.location.hostname + "/jsonreport.php?" + urlString,
            dataType: 'json',
			async: false,
            error: function(xhr, status, err) {
                console.log('ajax load error');
                alert('Ошибка загрузки матча: ' + err);
            },
            success: function(data) {
                dispatch({
					type: types.GET_GAME_JSON_SUCCESS,
					json: data
                });
            }.bind(this)
        });
    }
}

export function loadLocalJSON(source) {
    console.log('load local json from = ' + source);

    var data = require(`../sources/${source}`);

    return (dispatch) => {
        delay(10).then(()=> {
            dispatch({
                type: types.GET_GAME_JSON_SUCCESS,
                json: data
            });
        });
    }
}

export function SET_THEME(id) {
    return {
        type: types.SET_THEME,
        id: id
    }
}

export function MOVE_TO_NEXT_EVENT() {
    return (dispatch, getState) => {
        dispatch({ type: types.MOVE_TO_NEXT_EVENT });
    }
}

export function MOVE_TO_EVENT(num) {
    return {
        type: types.MOVE_TO_EVENT,
        num: num
    }
}

export function MOVE_TO_START(){
    return {
        type: types.MOVE_TO_START
    }
}

export function highlighPlayers(players) {
  var playerIds = [];
  for (var i = 0; i < players.length; i++) {
    playerIds.push(players[i].Id);
  }
  return {
      type: types.HIGHLIGHT_PLAYERS,
      playerIds: playerIds
  };
}

export function END_SCENE() {
    return { type: types.END_SCENE }
}


/** WEBPACK FOOTER **
 ** ./src/actions/gameActions.js
 **/